export const NEVER_INSTALLED_VIEW_MODE = 'neverInstalled';
export const INSTALL_ISSUE_VIEW_MODE = 'installIssue';
export const VERIFIED_VIEW_MODE = 'verified';

const VIEW_MODES = [
    NEVER_INSTALLED_VIEW_MODE,
    INSTALL_ISSUE_VIEW_MODE,
    VERIFIED_VIEW_MODE,
] as const;

export type FlowPreviewModalViewMode = (typeof VIEW_MODES)[number];

// NOTE: Which flow version a preview should show. Values must match the
//   backend enum, see: app/Enums/FlowPreviewVersion.php
export const CURRENT_FLOW_VERSION = 'current';
export const WORKING_COPY_FLOW_VERSION = 'working_copy';

const FLOW_VERSIONS = [
    CURRENT_FLOW_VERSION,
    WORKING_COPY_FLOW_VERSION,
] as const;

export type FlowPreviewVersion = (typeof FLOW_VERSIONS)[number];
